<div [class.offer-library-page]="!embedded">
  @if (!embedded) {
    <app-prevention-group-header activeTab="offers"></app-prevention-group-header>
    <div class="breadcrumb-bar">
      <button class="breadcrumb-back" (click)="goBack()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        {{ 'preventionOffres.library.back' | translate }}
      </button>
      <span class="breadcrumb-sep">·</span>
      <a class="breadcrumb-link" routerLink="/pilotage-prevention">{{ 'preventionOffres.library.breadcrumb.prevention' | translate }}</a>
      <span class="breadcrumb-sep">·</span>
      <a class="breadcrumb-link" routerLink="/prevention-offres">{{ 'preventionOffres.library.breadcrumb.offers' | translate }}</a>
      <span class="breadcrumb-sep">·</span>
      <span class="breadcrumb-current">{{ 'preventionOffres.library.breadcrumb.current' | translate }}</span>
    </div>
  }

  <div class="card" style="margin-bottom:16px">
    <div class="ct" style="margin-bottom:4px">{{ 'preventionOffres.library.title' | translate }}</div>
    <div class="cs" style="margin-bottom:14px">{{ 'preventionOffres.library.subtitle' | translate }}</div>
    <input
      class="input"
      type="text"
      [attr.aria-label]="'preventionOffres.library.searchAriaLabel' | translate"
      [placeholder]="'preventionOffres.library.searchPlaceholder' | translate"
      [value]="search()"
      (input)="onSearchChanged($any($event.target).value)">
  </div>

  @if (loadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.library.error' | translate }}</div></div>
  } @else if (loading()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.library.loading' | translate }}</div></div>
  } @else if (isGloballyEmpty()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.library.emptyGlobal' | translate }}</div></div>
  } @else if (hasSearchNoResults()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.library.emptySearch' | translate }}</div></div>
  } @else {
    <div class="lib-family-grid">
      @for (group of filteredGroups(); track group.family.code) {
        <div class="card">
        <div class="ct" style="margin-bottom:14px">{{ group.family.label }}</div>
        <div style="display:flex;flex-direction:column">
          @for (offer of group.offers; track offer.code) {
            <div class="lib-offer">
              @if (photoUrl(offer); as thumb) {
                <img class="lib-offer-thumb" [src]="thumb" alt="">
              }
              <div class="lib-offer-body">
                <div class="lib-offer-main">
                  <div class="lib-offer-name">{{ offer.name }}</div>
                  @if (offer.description) {
                    <div class="cs" style="margin-top:2px">{{ offer.description }}</div>
                  }
                  <div class="cs" style="margin-top:8px">
                    {{ (offer.bilans.length > 1 ? 'preventionOffres.library.bilanCountPlural' : 'preventionOffres.library.bilanCountSingular') | translate: { count: offer.bilans.length } }}
                  </div>
                  <ul class="bilan-items-list">
                    @for (bilan of offer.bilans; track bilan.code) {
                      <li>{{ bilan.name }}</li>
                    }
                  </ul>
                </div>
                <div class="lib-offer-actions">
                  @if (embedded && isAdded(offer.code) && !isActiveOnCurrentSite(offer.code)) {
                    <span class="lib-added-badge lib-added-badge--muted">{{ 'preventionOffres.library.inGroupCatalogBadge' | translate }}</span>
                    <button class="btn-green-sm" (click)="onConfigureClick(offer.code)">{{ 'preventionOffres.library.activateForSiteButton' | translate }}</button>
                  } @else if (isAdded(offer.code)) {
                    <span class="lib-added-badge">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
                      {{ (embedded ? 'preventionOffres.library.addedToSiteBadge' : 'preventionOffres.library.addedBadge') | translate }}
                    </span>
                  } @else {
                    <button class="btn-secondary-sm" (click)="viewOffer(offer.code)">{{ 'preventionOffres.library.viewButton' | translate }}</button>
                    <button class="btn-green-sm" [disabled]="addingCode() === offer.code" (click)="addDirectly(offer)">{{ 'preventionOffres.library.addButton' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        </div>
      }
    </div>
  }
</div>
